export enum TrainingEmailEventTypes {
    Training_Event_Reminder = 800,
    Training_Event_NoShows = 801,
    Training_Event_Setup = 802,
    Training_Event_Certificate = 803,
    Training_Event_Registration_Confirmation = 804,
    Training_Event_Self_Cancellation = 805
}
